import { Logger } from './logger';

/**
 * @param {object[]} queryProducts   - array of quired product objects with userAddedItems added
 */
export function productsInquiry(queryProducts) {
	// const idOriginal =
	// 	product?.id_original ?? product.cms_product_name ?? product?.id_cad ?? null;

    const queriedProductsDetails = queryProducts.map((product) => ({
      investmentId: product?.crm_id_investment ?? null,
      stageId: product?.crm_id_stage ?? null,
      buildingId: product?.crm_id_building ?? null,
      unitId: product?.crm_id_unit ?? product?.number ?? product?.id_cad ?? null,
      unitName: product?.id_original ?? product.cms_product_name ?? product?.id_cad ?? null,
      userAddedItems: product?.userAddedItems ?? null
    }))

	const eventDetail = {
        units: [...queriedProductsDetails]
		// units: [
		// 	{
		// 		investmentId: product?.crm_id_investment ?? null,
		// 		stageId: product?.crm_id_stage ?? null,
		// 		buildingId: product?.crm_id_building ?? null,
		// 		unitId:
		// 			product?.crm_id_unit ?? product?.number ?? product?.id_cad ?? null,
		// 		unitName: idOriginal,
		// 		userAddedItems: null,
		// 	},
		// ],
	};

	Logger.info({
		message: 'cadaplusProductQueryClick event dispatched',
		content: `${JSON.stringify(eventDetail)}`,
	});
	const event = new CustomEvent('cadaplusProductQueryClick', {
		detail: {
			...eventDetail,
		},
		bubbles: true,
		composed: true,
	});

	document.dispatchEvent(event);
}


export function futurePhaseInquiry(phase) {
	const {
		phaseName,
		buildingName
	} = phase

    const eventDetail = {
        phaseName,
		buildingName
    }
    
	Logger.info({
		message: 'cadaplusPhaseQueryClick event dispatched',
		content: `${JSON.stringify(eventDetail)}`,
	});
	const event = new CustomEvent('cadaplusPhaseQueryClick', {
		detail: {
			...eventDetail,
		},
		bubbles: true,
		composed: true,
	});

	document.dispatchEvent(event);

}